import ExpansionPanel from './ExpansionPanel.logic'
export default ExpansionPanel
